module.exports = __webpack_public_path__ + "img/best_mb@2x.6925f654.png";